'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var generateShimmerCss = require('./generateShimmerCss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Photo = styled__default["default"].div.withConfig({
  componentId: "sc-i8mqhk-0"
})(["height:90px;width:90px;grid-area:Photo;grid-template-rows:span(2);", ""], generateShimmerCss["default"]({
  start: '-1040px',
  stop: '1040px',
  size: '1040px'
}));
const Title = styled__default["default"].div.withConfig({
  componentId: "sc-i8mqhk-1"
})(["height:24px;max-width:307px;width:100%;grid-area:Title;align-self:start;justify-self:start;", ""], generateShimmerCss["default"]({
  start: 'calc(-1040px - 140px)',
  stop: 'calc(1040px - 140px)',
  size: '1040px'
}));
const Description = styled__default["default"].div.withConfig({
  componentId: "sc-i8mqhk-2"
})(["height:24px;max-width:156px;width:100%;grid-area:Description;align-self:start;justify-self:start;", ""], generateShimmerCss["default"]({
  start: 'calc(-1040px - 140px)',
  stop: 'calc(1040px - 140px)',
  size: '1040px'
}));
const Fee = styled__default["default"].div.withConfig({
  componentId: "sc-i8mqhk-3"
})(["height:24px;max-width:72px;width:100%;align-self:start;justify-self:end;", ""], generateShimmerCss["default"]({
  start: 'calc(-1040px - calc(520px - 100%))',
  stop: 'calc(1040px - calc(520px - 100%))',
  size: '1040px'
}));
const Container = styled__default["default"].div.withConfig({
  componentId: "sc-i8mqhk-4"
})(["box-sizing:border-box;padding:16px;border-width:1px;border-style:solid;border-radius:4px;border-color:#cccccc;display:grid;grid-auto-flow:column;width:100%;grid-template-areas:'Photo Title Fee' 'Photo Description .';grid-template-columns:auto 2fr 1.25fr;column-gap:24px;"]);
const PudoCardSkeleton = () => /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(Photo, null), /*#__PURE__*/React__default["default"].createElement(Title, null), /*#__PURE__*/React__default["default"].createElement(Description, null), /*#__PURE__*/React__default["default"].createElement(Fee, null));

exports.PudoCardSkeleton = PudoCardSkeleton;
